import Image from 'next/image';
import { BLUR_DATAURL } from './constants';

export default function InfoDefault() {
  return <>
    <div className="invisible md:visible fixed top-1/2 left-1/4 transform -translate-x-1/2 -translate-y-1/2">
      <div className="relative flex min-h-screen flex-col items-end justify-center py-6 sm:py-12">
        <div className="relative bg-white px-6 pt-10 pb-8 shadow-xl ring-1 ring-gray-900/5 sm:mr-10 sm:max-w-lg sm:rounded-xl sm:px-10">
          <div className="mx-auto max-w-md">
            <Image
              src="/images/logo.png"
              alt="투어캐스트"
              width="0"
              height="0"
              sizes="100vw"
              className="w-36 h-auto"
              loading="lazy"
              placeholder="blur"
              blurDataURL={BLUR_DATAURL}
            />

            <div className="divide-y divide-gray-300">
              <div className="space-y-6 py-8 leading-7">
                <p className="text-3xl font-thin leading-3">여행객을 위한</p>
                <p className="text-3xl font-bold text-neutral-600">100% 무료 가이드북</p>

                <div className="w-14 border-b border-neutral-300 dark:border-neutral-700"></div>

                <ul className="space-y-4">
                  <li className="flex items-center">
                    <i className="las la-check-circle text-2xl"></i>
                    <p className="ml-4 mb-0">
                      여행사 근무 노하우로 만든 가이드북
                    </p>
                  </li>
                  <li className="flex items-center">
                    <i className="las la-check-circle text-2xl"></i>
                    <p className="ml-4 mb-0">
                      그 어디서도 볼 수 없는 여행 꿀팁
                    </p>
                  </li>
                  <li className="flex items-center">
                    <i className="las la-check-circle text-2xl"></i>
                    <p className="ml-4 mb-0">
                      할인 & 쿠폰 제공
                    </p>
                  </li>
                </ul>

                <div className="w-14 border-b border-neutral-300 dark:border-neutral-700"></div>

                <p className="">
                  투어캐스트는 여행객을 위해 일정을 쉽게 짤 수 있게 가이드 라인을 제시함으로써 누구나 쉽게 여행을 즐길 수 있게 도와줍니다.<br />
                  <span className="text-sm text-neutral-400">문의: tourcast.help@gmail.com</span><br />
                  <span className="text-xs text-neutral-400">(여행관련 문의는 앱 내의 Q&A에 올려주세요!)</span>
                </p>
              </div>

              <div className="pt-8 leading-7">
                <p className="font-thin">
                  전체 가이드북은
                </p>
                <p className="">
                  투어캐스트 앱으로 만나보세요!
                </p>
                <div className="grid grid-cols-2 gap-1 font-light">
                  <div>iOS</div>
                  <div>안드로이드</div>
                  <div className="border-solid border-2 border-neutral-300 rounded-md w-24 items-center">
                    <Image
                      src="/images/ios.png"
                      alt="iOs"
                      width="0"
                      height="0"
                      sizes="100vw"
                      className="w-24 h-auto p-1"
                      loading="lazy"
                      placeholder="blur"
                      blurDataURL={BLUR_DATAURL}
                    />
                  </div>
                  <div className="border-solid border-2 border-neutral-300 rounded-md w-24 items-center">
                    <Image
                      src="/images/android.png"
                      alt="android"
                      width="0"
                      height="0"
                      sizes="100vw"
                      className="w-24 h-auto p-1"
                      loading="lazy"
                      placeholder="blur"
                      blurDataURL={BLUR_DATAURL}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="listingSection__wrap">
                <h2 className="text-2xl font-semibold">Stay information</h2>
                <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>;
}